import { Injectable } from '@angular/core';

import { SidenavItem } from './sidenav-item/sidenav-item.interface';
import { RunTimeDataService } from '@leandredev/common-ng16/infraService';

/**
 * Menu pour un admin.
 */
const normalAdminMenu: SidenavItem[] = [
  { name: 'Application Admin', type: 'subheading', customClass: 'first-subheading' },
  { routeOrFunction: '/data/ServiceDeployed/list/', name: 'Service Deployed', icon: 'build', pathMatchExact: true },
  { routeOrFunction: '/stats/', name: 'Platform usage', icon: 'bar_chart', pathMatchExact: true },
  { routeOrFunction: '/data/CopywriterStyleRecord/list/', name: 'Copywriter Styles', icon: 'history_edu', pathMatchExact: true },
  { routeOrFunction: '/apiError/', name: 'Api Errors', icon: 'error', pathMatchExact: true },

  { name: 'Documents Admin', type: 'subheading' },
  { routeOrFunction: '/data/Tag/list', name: 'Tags de documents', icon: 'feedback', pathMatchExact: true },
  { routeOrFunction: '/data/TagType/list', name: 'Type des Tags', icon: 'bookmark', pathMatchExact: true },
  { routeOrFunction: '/data/ExternalTagTypeMapper/list/', name: 'ExternalTagTypeMapper', icon: 'history_edu', pathMatchExact: true },
  { routeOrFunction: '/data/ExternalTagMapper/list/', name: 'ExternalTagMapper', icon: 'history_edu', pathMatchExact: true },

  { name: 'Utilisateurs', type: 'subheading' },
  { routeOrFunction: '/data/UserClient/list', name: 'Clients app', icon: 'person', pathMatchExact: true },
  { routeOrFunction: '/data/UserClientGroup/list', name: 'Groupes d’utilisateurs', icon: 'group_work', pathMatchExact: true }
];

/**
 * Menu pour un super administrateur.
 */

const superAdminMenu: SidenavItem[] = [
  { name: 'Application Admin', type: 'subheading', customClass: 'first-subheading' },
  { routeOrFunction: '/data/ServiceDeployed/list/', name: 'Service Deployed', icon: 'build', pathMatchExact: true },
  { routeOrFunction: '/stats/', name: 'Platform usage', icon: 'bar_chart', pathMatchExact: true },
  { routeOrFunction: '/apiError/', name: 'Api Errors', icon: 'error', pathMatchExact: true },
  { routeOrFunction: '/data-privacy/', name: 'Data Privacy', icon: 'locker', pathMatchExact: true },
  { routeOrFunction: '/data/UserRole/list/', name: 'Roles', icon: 'apps', pathMatchExact: true },
  { routeOrFunction: '/data/ExternalRoleMapper/list/', name: 'Roles Mapper', icon: 'apps', pathMatchExact: true },
  { routeOrFunction: '/data/Assistant/list/', name: 'Assistants', icon: 'apps', pathMatchExact: true },
  { routeOrFunction: '/data/AvailableAiModels/list/', name: 'Models', icon: 'psychology', pathMatchExact: true },
  { routeOrFunction: '/data/CopywriterStyleRecord/list/', name: 'Copywriter Styles', icon: 'history_edu', pathMatchExact: true },
  { routeOrFunction: '/data/TranslatorStyle/list/', name: 'Translator Styles', icon: 'translate', pathMatchExact: true },
  { routeOrFunction: '/data/AdaptivIcon/list', name: 'Icones ', icon: 'info', pathMatchExact: true },
  { routeOrFunction: '/data/Template/list', name: 'Template', icon: 'apps', pathMatchExact: true },

  { name: 'Documents Admin', type: 'subheading' },
  { routeOrFunction: '/data/Tag/list', name: 'Tags de documents', icon: 'feedback', pathMatchExact: true },
  { routeOrFunction: '/data/TagType/list', name: 'Type des Tags', icon: 'bookmark', pathMatchExact: true },
  { routeOrFunction: '/data/ExternalTagTypeMapper/list/', name: 'ExternalTagTypeMapper', icon: 'history_edu', pathMatchExact: true },
  { routeOrFunction: '/data/ExternalTagMapper/list/', name: 'ExternalTagMapper', icon: 'history_edu', pathMatchExact: true },

  { name: 'AGENT X Admin', type: 'subheading' },
  { routeOrFunction: '/data/AGXToolBox/list', name: 'ToolBox', icon: 'feedback', pathMatchExact: true },
  { routeOrFunction: '/data/AGXCo2Emission/list', name: 'CO2 emissions', icon: 'local_gas_station', pathMatchExact: true },

  { name: 'Shared Library', type: 'subheading' },
  { routeOrFunction: '/sharedLibraryCatalog', name: 'Catalog', icon: 'store', pathMatchExact: true },
  { routeOrFunction: '/data/SharedLibrarySubscription/list/', name: 'Subscription', icon: 'build', pathMatchExact: true },
  { routeOrFunction: '/data/SharedLibraryApiKey/list/', name: 'API keys', icon: 'build', pathMatchExact: true },

  { name: 'Utilisateurs', type: 'subheading' },
  { routeOrFunction: '/data/UserAdmin/list', name: 'Utilisateurs Admin', icon: 'people', pathMatchExact: true },
  { routeOrFunction: '/data/UserClient/list', name: 'Clients app', icon: 'person', pathMatchExact: true },
  { routeOrFunction: '/data/UserMcp/list', name: 'Clients MCP', icon: 'settings_input_antenna', pathMatchExact: true },
  { routeOrFunction: '/data/UserClientGroup/list', name: 'Groupes d’utilisateurs', icon: 'group_work', pathMatchExact: true },

  { name: 'Super Admin Debug', type: 'subheading' },
  { routeOrFunction: '/data/ImportingFile/list/', name: 'Import de documents', icon: 'dashboard', pathMatchExact: true },
  { routeOrFunction: '/data/ConvertingFile/list/', name: 'Conversion de documents', icon: 'dashboard', pathMatchExact: true },
  { routeOrFunction: '/llm-actions-list', name: 'LLM Messages', icon: 'all_inbox', pathMatchExact: true },
  { routeOrFunction: '/data/adaptivLog/list', name: 'Logs', icon: 'bug_report', pathMatchExact: true }
];

@Injectable()
export class SidenavNavigationData {
  public navigationAppItems: SidenavItem[] = [];

  constructor(protected runtimeDataProvider: RunTimeDataService) {
    this.runtimeDataProvider.getObservableStore('ConfService').subscribe((data: { superAdmin: boolean }) => {
      if (data && data.superAdmin) {
        this.navigationAppItems = superAdminMenu;
      } else {
        this.navigationAppItems = normalAdminMenu;
      }
    });
  }

  openQuickPanel(): void {
    return;
  }
}
